import blockedWords from './blockedWords'
import * as R from 'ramda'

const generateNewFormattedString = array => {
  R.mapObjIndexed((word, index) => {
    R.map(blockedWord => {
      if (R.includes(blockedWord, R.toUpper(removeAccents(word)))) {
        const newString = generateNewString(blockedWord, word)
        array.splice(index, 1, newString)
      }
    }, blockedWords)
  }, array)

  return R.join(' ', array)
}

const generateNewString = (blockedWord, string) => {
  const characters = ['@', '#', '%', '*', '!', '~', '&', '?', '$']

  const portionToReplace = blockedWord.substr(1)

  let newPortion = ''
  for (let i = 0; i < portionToReplace.length; i++) {
    newPortion += characters[Math.floor(Math.random() * characters.length)]
  }

  return R.replace(
    R.toLower(portionToReplace),
    R.toLower(newPortion),
    R.toLower(string),
  )
}

const removeAccents = string => {
  let withAccent =
    'ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝŔÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿŕ'
  let withoutAccent =
    'AAAAAAACEEEEIIIIDNOOOOOOUUUUYRsBaaaaaaaceeeeiiiionoooooouuuuybyr'
  let newStr = ''
  for (let i = 0; i < string.length; i++) {
    let remove = false
    for (let a = 0; a < withAccent.length; a++) {
      if (string.substr(i, 1) == withAccent.substr(a, 1)) {
        newStr += withoutAccent.substr(a, 1)
        remove = true
        break
      }
    }
    if (remove == false) {
      newStr += string.substr(i, 1)
    }
  }
  return newStr
}

export { generateNewFormattedString }
